module.exports = __webpack_public_path__ + "static/img/class-room-recording1.d68123b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ela/class-room-recording1.jpg
// module id = Htl4
// module chunks = 1